import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BenefitsBar } from './components/BenefitsBar';
import { ProjectSection } from './components/ProjectSection';
import { Amenities } from './components/Amenities';
import { LotMap } from './components/LotMap';
import { CreditSimulator } from './components/CreditSimulator';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Financing } from './components/Financing';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { formatQ } from './utils/format';
import type { Lote } from './types/lote';
const SEO = {
  /** Texto de la pestaña del navegador */
  title: 'AR Corporacion',
  /** Título para redes sociales al compartir el enlace */
  ogTitle: 'Hacienda El Rodeo | Lotes desde Q35,000 en Santa Catarina Mita — AR Corporacion',
  description: 'Lotes residenciales en Hacienda El Rodeo, Santa Catarina Mita, Jutiapa. Financiamiento directo sin banco, enganche desde Q10,000 y escrituración incluida.'
};

/** Meta tags básicos + Open Graph para SEO. */
function useSeo() {
  useEffect(() => {
    document.title = SEO.title;
    const tags: Array<[string, string, string]> = [['name', 'description', SEO.description], ['property', 'og:title', SEO.ogTitle], ['property', 'og:description', SEO.description], ['property', 'og:type', 'website'], ['property', 'og:image', 'https://cdn.magicpatterns.com/uploads/gzi9SBtBVPokictz7gLeCR/img3.jpg'], ['name', 'twitter:card', 'summary_large_image']];
    tags.forEach(([attr, key, content]) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });
  }, []);
}
export function App() {
  useSeo();
  const [leadMessage, setLeadMessage] = useState('');
  const goToContact = (message: string) => {
    setLeadMessage(message);
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const handleApartar = (lote: Lote) => goToContact(`Quiero apartar el Lote ${lote.numero} (${lote.medidas}, ${lote.area} m²) con precio de ${formatQ(lote.precio)}.`);
  return <div className="w-full bg-white" data-id="element-0" data-mp="3bnus18yxo8ih">
      <Navbar data-id="element-1" data-mp="3qb7lrkyw9kjy" />
      <main data-id="element-2" data-mp="3qbpql5zmh73h">
        <Hero data-id="element-3" data-mp="3qc96yi9mjnfe" />
        <BenefitsBar data-id="element-4" data-mp="3qbzcoihjqu3w" />
        <ProjectSection data-id="element-5" data-mp="3qdaienujybxn" />
        <Amenities data-id="element-6" data-mp="3lkhbpufiwtix" />
        <LotMap onApartar={handleApartar} data-id="element-7" data-mp="3lk7mi92ayqea" />
        <CreditSimulator onSolicitar={goToContact} data-id="element-8" data-mp="3lj6bu5p785x3" />
        <Gallery data-id="element-9" data-mp="2xu3jo3wxuuoc" />
        <Testimonials data-id="element-10" data-mp="2xtlqxh9hiyl6" />
        <Financing data-id="element-11" data-mp="2xt29s2rnse87" />
        <ContactForm prefillMessage={leadMessage} data-id="element-12" data-mp="2xsk3sef72ln3" />
      </main>
      <Footer data-id="element-13" data-mp="2svagb4bd8k1w" />
      <WhatsAppButton data-id="element-14" data-mp="2svjyw6u2zoxk" />
    </div>;
}